export default {
      id: "ic-canli-bahis-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-canli-bahis-usage",
      toString: function () {
        return this.url;
      }
    }